import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import CalendarCountRq from '@domain/rq/calendar/CalendarCountRq';
import CalendarPcListRq from '@domain/rq/calendar/CalendarPcListRq';
import CalendarUserFilterRq from '@domain/rq/calendar/CalendarUserFilterRq';
import { CalendarPcListRs } from '@domain/rs/calendar/CalendarPcListRs';
import { JobTitleSearchListRs } from '@domain/rs/calendar/JobTitleSearchListRs';
import { CalendarUserFilterRs } from '@domain/rs/calendar/CalendarUserFilterRs';

const calendarPrefix = '/calendar';

export default interface CalendarRepo {
  //공고 개수 조회
  fetchCalendarCount(rq: CalendarCountRq): Promise<AxiosResponse<number>>;

  //채용 캘린더 리스트 조회
  fetchCalendarPcList(rq: CalendarPcListRq): Promise<AxiosResponse<CalendarPcListRs>>;

  //직무 검색
  fetchSearchJobTitle(keyword: string): Promise<AxiosResponse<JobTitleSearchListRs>>;

  //최근 필터 조회
  fetchCalendarFilter(): Promise<AxiosResponse<CalendarUserFilterRs>>;

  //최근 필터 저장
  updateCalendarFilter(rq: CalendarUserFilterRq): Promise<AxiosResponse>;
}

export class RemoteCalendarRepo implements CalendarRepo {
  fetchCalendarCount(rq: CalendarCountRq): Promise<AxiosResponse<number>> {
    return axios.get(`${calendarPrefix}/count`, { params: rq });
  }

  fetchCalendarPcList(rq: CalendarPcListRq): Promise<AxiosResponse<CalendarPcListRs>> {
    return axios.get(`${calendarPrefix}/pc/list`, { params: rq });
  }

  fetchSearchJobTitle(keyword: string): Promise<AxiosResponse<JobTitleSearchListRs>> {
    return axios.get(`${calendarPrefix}/search/job-title`, { params: { keyword } });
  }

  fetchCalendarFilter(): Promise<AxiosResponse<CalendarUserFilterRs>> {
    return axios.get(`${calendarPrefix}/filter`);
  }

  updateCalendarFilter(rq: CalendarUserFilterRq): Promise<AxiosResponse> {
    return axios.post(`${calendarPrefix}/filter`, rq);
  }
}
